import { Element } from "@xmpp/xml"
import { jid } from "@xmpp/client"
import { RouteInfo } from "../components/maps/RouteView"

type RoutePolylines = {
  type: "result" | "error"
  from: ReturnType<typeof jid.parse>
  to: ReturnType<typeof jid.parse>
  id: string
  node: string
  sessionId: string
  status: string
  route: RouteInfo
}

export default class RoutePolylinesParser {
  static parse(stanza: Element): RoutePolylines | undefined {
    if (
      stanza.name !== "iq" ||
      !stanza.getAttr("from") ||
      !stanza.getAttr("to")
    )
      return

    const from = jid.parse(stanza.getAttr("from"))
    const to = jid.parse(stanza.getAttr("to"))
    const type = stanza.getAttr("type")
    const id = stanza.getAttr("id")

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const node = command.getAttr("node")
    const sessionId = command.getAttr("sessionid")
    const status = command.getAttr("status")

    const json = command.getChild("json", "urn:xmpp:json:0")
    if (!json) return
    let route
    try {
      route = JSON.parse(json!.text())
    } catch (e) {
      console.log("Invalid JSON format in route")
    }

    return {
      type: type as "result" | "error",
      from,
      to,
      id,
      node,
      sessionId,
      status,
      route,
    }
  }
}
